import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=4b493862&scoped=true&"
import script from "./StripePayment.vue?vue&type=script&lang=ts&"
export * from "./StripePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b493862",
  null
  
)

export default component.exports